import { Slider as AntSlider, theme } from 'antd';
import type { GlobalToken, SliderSingleProps } from 'antd';
import styled from 'styled-components';

export type SliderProps = SliderSingleProps;

/**
 * Single-value slider with a gradient track.
 * Extends Ant Design's Slider; colors follow the nearest ConfigProvider.
 *
 * @example
 * ```tsx
 * <Slider min={0} max={100} value={value} onChange={setValue} />
 * ```
 */
export const Slider = (props: SliderProps) => {
  const { token } = theme.useToken();

  return <StyledSlider $token={token} {...props} />;
};

export default Slider;

// ─── Styled components ───

const StyledSlider = styled(AntSlider)<{ $token: GlobalToken }>`
  margin: 8px 0 2px;

  .ant-slider-rail {
    background: ${({ $token }) => $token.colorFillSecondary};
  }

  .ant-slider-track,
  &:hover .ant-slider-track {
    background: linear-gradient(
      90deg,
      ${({ $token }) => $token.colorPrimary},
      ${({ $token }) => $token.colorPrimaryBorderHover}
    );
  }

  .ant-slider-handle::after {
    box-shadow: 0 0 0 2px ${({ $token }) => $token.colorPrimary};
  }
`;
